import { generatePath } from 'react-router-dom';
import { URLS } from 'services/urls';
import { NS_LOGO_URL } from 'constants/branding';
import { DealLite } from 'views/Deals/hooks/useGetOrganizationDealsLite';
import { OrganizationSubproject } from 'views/ProFormaTable/types';
import { coverPictureToIcon } from '../helpers';
import { SIDE_NAV_TEST_IDS } from '../../../constants';
import ProjectsDealsMenuItem from '../ProjectsDealsMenuItem/ProjectsDealsMenuItem';
import './ProjectsDealsMenu.scss';

interface IProjectsDealsMenuProps {
    projects?: OrganizationSubproject[];
    deals?: DealLite[];
    currentDealId?: number;
    onSelect?: () => void;
}

export const buildDealSubtitle = (deal: Pick<DealLite, 'city' | 'state'>): string => (
    [deal.city, deal.state].filter(Boolean).join(', ')
);

const ProjectsDealsMenu = ({
    projects, deals, currentDealId, onSelect,
}: IProjectsDealsMenuProps) => {
    const showProjects = Boolean(projects && projects.length > 0);
    const showDeals = Boolean(deals && deals.length > 0);

    return (
        <div
            className="ProjectsDealsMenu py-2 overflow-auto"
            data-testid={SIDE_NAV_TEST_IDS.SWITCHER_DROPDOWN}
            role="menu"
        >
            {showProjects && (
                <>
                    <div className="font-10 pl-2 pb-0">
                        PROJECTS
                    </div>
                    {(projects || []).map(project => (
                        <ProjectsDealsMenuItem
                            key={`project-${project.subprojectId}`}
                            to={URLS.PROJECTS_APP.PROJECT_DASHBOARD_V2(project.subprojectId)}
                            isExternal
                            imgSrc={coverPictureToIcon(project.subproject.coverPicture)}
                            imgAlt="Project"
                            name={project.subproject.subprojectName}
                            subtitle={project.subproject.developmentProject.projectName}
                            title={project.subproject.subprojectName}
                            testId={SIDE_NAV_TEST_IDS.SWITCHER_PROJECT_ITEM}
                            onClick={onSelect}
                        />
                    ))}
                </>
            )}

            {showDeals && (
                <>
                    <div className="font-10 pl-2 pb-0">
                        DEALS
                    </div>
                    {deals!.map(deal => (
                        <ProjectsDealsMenuItem
                            key={`deal-${deal.id}`}
                            to={generatePath(URLS.DEAL_DASHBOARD.HOME, { dealId: String(deal.id) })}
                            imgSrc={NS_LOGO_URL}
                            imgAlt="Northspyre"
                            name={deal.dealName}
                            subtitle={buildDealSubtitle(deal)}
                            title={deal.dealName}
                            testId={SIDE_NAV_TEST_IDS.SWITCHER_DEAL_ITEM}
                            isActive={deal.id === currentDealId}
                            onClick={onSelect}
                        />
                    ))}
                </>
            )}

            {!showProjects && !showDeals && (
                <div className="p-2 font-10 text-center">
                    No projects or deals available
                </div>
            )}
        </div>
    );
};

export default ProjectsDealsMenu;
